export default __webpack_public_path__ + "../staticImages/winefinder-sprite-taste-01.png";